document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      const open = nav.hasAttribute('hidden');
      if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = button.parentElement?.querySelector('[data-faq-panel]');
      if (!panel) return;
      const open = !panel.hasAttribute('hidden');
      document.querySelectorAll('[data-faq-panel]').forEach((p) => p.setAttribute('hidden', ''));
      document.querySelectorAll('[data-faq-button]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (!open) {
        panel.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (!form) return;
      const id = select.value;
      const input = form.querySelector('input[name="id"]');
      if (input) input.value = id;
      const option = select.options[select.selectedIndex];
      const root = form.closest('[data-product-root]');
      const price = root?.querySelector('[data-product-price]');
      if (price && option?.dataset?.price) price.textContent = option.dataset.price;
      const compare = root?.querySelector('[data-product-compare]');
      if (compare) {
        if (option?.dataset?.compare) { compare.textContent = option.dataset.compare; compare.hidden = false; }
        else compare.hidden = true;
      }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-variant-button]');
    const input = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const buyButton = root.querySelector('[data-buy-button]');
    const buyLabel = root.querySelector('[data-buy-label]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        buttons.forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        if (input) input.value = button.dataset.id || '';
        if (price && button.dataset.price) price.textContent = button.dataset.price;
        if (compare) {
          if (button.dataset.compare) {
            compare.textContent = button.dataset.compare;
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
        const available = button.dataset.available === 'true';
        if (buyButton) buyButton.disabled = !available;
        if (buyLabel) buyLabel.textContent = available ? 'أضف إلى السلة' : 'غير متوفر حاليًا';
        if (button.dataset.id && window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', button.dataset.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const blur = gallery.querySelector('[data-gallery-blur]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (thumb.dataset.src) main.src = thumb.dataset.src;
        if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
        if (blur && thumb.dataset.blur) blur.style.backgroundImage = `url("${thumb.dataset.blur}")`;
      });
    });
  });
});
